import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "TutorRankings";

export async function getTutorRanking() {
  return await axiosInstance.get(`/${baseAPIUrl}/top-ranking`);
}